export const BASE_MARKETPLACES_APPS = '/v1/marketplaces-apps';
